import { useEffect, useState } from 'react';
import { useGamificationStore } from '../../../stores/gamification-store.js';

export function XPFloat() {
  const { pendingXP, clearXP } = useGamificationStore();
  const [visible, setVisible] = useState(false);
  const [displayXP, setDisplayXP] = useState(0);

  useEffect(() => {
    if (pendingXP <= 0) return;

    setDisplayXP(pendingXP);
    setVisible(true);

    const timer = setTimeout(() => {
      setVisible(false);
      clearXP();
    }, 1500);

    return () => clearTimeout(timer);
  }, [pendingXP, clearXP]);

  if (!visible || displayXP <= 0) return null;

  return (
    <>
      <style>{`
        @keyframes xp-float {
          0%   { opacity: 0; transform: translateY(0px); }
          15%  { opacity: 1; }
          80%  { opacity: 1; }
          100% { opacity: 0; transform: translateY(-30px); }
        }
        .xp-float-anim {
          animation: xp-float 1.5s ease-out forwards;
        }
      `}</style>
      <div
        className="xp-float-anim pointer-events-none fixed right-6 top-20 z-50 text-lg font-bold text-xd-xp drop-shadow-md"
        aria-hidden="true"
      >
        +{displayXP} XP
      </div>
    </>
  );
}
